import StubPage from "./StubPage";
import { Calendar, Megaphone, Users, MapPin } from "lucide-react";
export default function Events() {
  return <StubPage eyebrow="Events" title="National Karate Calendar"
    subtitle="From district league matches to international friendship cups — every official NKF Bharat event in one calendar."
    sections={[
      { icon: Calendar, title: "Annual Calendar 2026", body: "The NKF Bharat 2026 Annual Planner is now released with the complete year-round event schedule." },
      { icon: Megaphone, title: "Excellence & Iconic Awards 2025", body: "The federation's flagship recognition programme for outstanding coaches, academies and athletes." },
      { icon: Users, title: "Coach & Referee Camps", body: "Quarterly technical seminars at federation regional centres across all three disciplines." },
      { icon: MapPin, title: "State Conventions", body: "Annual state-level conventions in Karnataka, Odisha, Chhattisgarh, West Bengal and other affiliated regions." },
    ]}
  />;
}
